import { getCurrentLanguage, SupportedLanguages } from 'utils/current-language'
import { Language } from 'models/cookies'

import pl from 'i18n/languages/pl'
import en from 'i18n/languages/en'
import uk from 'i18n/languages/uk'
import ru from 'i18n/languages/ru'
import de from 'i18n/languages/de'
import sk from 'i18n/languages/sk'
import es from 'i18n/languages/es'
import cs from 'i18n/languages/cs'
import ro from 'i18n/languages/ro'
import fr from 'i18n/languages/fr'
import it from 'i18n/languages/it'

const translations: Record<SupportedLanguages, any> = {
  [SupportedLanguages.pl]: pl,
  [SupportedLanguages.en]: en,
  [SupportedLanguages.uk]: uk,
  [SupportedLanguages.ru]: ru,
  [SupportedLanguages.de]: de,
  [SupportedLanguages.sk]: sk,
  [SupportedLanguages.es]: es,
  [SupportedLanguages.cs]: cs,
  [SupportedLanguages.ro]: ro,
  [SupportedLanguages.fr]: fr,
  [SupportedLanguages.it]: it,
}

const getNestedValue = (obj: any, path: string[]): string | undefined => {
  return path.reduce((acc, key) => acc?.[key], obj)
}

const interpolate = (str: string, vars: Record<string, string> = {}): string => {
  return str.replace(/{{\s*(\w+)\s*}}/g, (_, key) => vars[key] ?? '')
}

export const t9n = (key: string, vars?: Record<string, string>, lang: Language = getCurrentLanguage()): string => {
  const messages = translations[lang] || translations[SupportedLanguages.pl]
  const path = key.split('.')
  const raw = getNestedValue(messages, path)
  return raw ? interpolate(raw, vars) : key
}
